import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigationData } from '../../modules/NavigationProvider';
import { usePolesContext } from '../../modules/poles/PolesContext';
import logo from '../../assets/img/logo-text.png';

const Footer: React.FC = () => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const { buttonText, path } = useNavigationData();
  const { setPoleId } = usePolesContext();

  return (
    <div className="position-relative mt-auto">
      <div className="d-flex justify-content-center">
        <img src={logo} height={70} alt="vihupole" />
      </div>
      {path && (
        <Button
          variant="outline-dark"
          size="sm"
          onClick={() => (path === '/map' ? setPoleId() : navigate(path))}
          className="position-absolute bottom-0 end-0 translate-middle-y text-uppercase"
        >
          {buttonText ?? t('back')}
        </Button>
      )}
    </div>
  );
};

export default Footer;
